import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from "../../dropdown";
import { ActivePills } from "./active-pills";
import { useActionsContext, usePanelContext } from "./context";
import { FilterList, Panel, QuickApply, Search, Trigger } from "./menu";
import { TableFiltersProvider } from "./provider";
import type { FilterTypeConfig } from "./types";
export type { ComparisonType, DatePreset, FilterTypeConfig, SearchResult } from "./types";
interface TableFiltersProps<T extends Record<string, any>> {
  filterTypes: FilterTypeConfig[];
  filters: T;
  onFilterChange: (key: keyof T, value: any) => void;
  className?: string;
  /**
   * Show each applied filter as an editable pill beside the trigger (default).
   * Turn off where space is tight: the trigger's count still shows how many
   * filters are on, and the panel lists their values.
   */
  showActivePills?: boolean;
}
function ComposedRoot(t0) {
  const $ = _c(12);
  const {
    className,
    showActivePills
  } = t0;
  const {
    isOpen
  } = usePanelContext();
  const {
    setOpen
  } = useActionsContext();
  let t1;
  if ($[0] !== className) {
    t1 = <Trigger className={className} />;
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Panel />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isOpen || $[4] !== setOpen || $[5] !== t1) {
    t3 = <DropdownMenu open={isOpen} onOpenChange={setOpen} modal={false}>{t1}{t2}</DropdownMenu>;
    $[3] = isOpen;
    $[4] = setOpen;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showActivePills) {
    t4 = showActivePills && <ActivePills />;
    $[7] = showActivePills;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-wrap items-center gap-1">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function TableFilters(t0) {
  const $ = _c(8);
  const {
    filterTypes,
    filters,
    onFilterChange,
    className,
    showActivePills: t1
  } = t0;
  const showActivePills = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className || $[1] !== showActivePills) {
    t2 = <ComposedRoot className={className} showActivePills={showActivePills} />;
    $[0] = className;
    $[1] = showActivePills;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== filterTypes || $[4] !== filters || $[5] !== onFilterChange || $[6] !== t2) {
    t3 = <TableFiltersProvider filterTypes={filterTypes} filters={filters} onFilterChange={onFilterChange}>{t2}</TableFiltersProvider>;
    $[3] = filterTypes;
    $[4] = filters;
    $[5] = onFilterChange;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
TableFilters.Provider = TableFiltersProvider;
TableFilters.Trigger = Trigger;
TableFilters.Panel = Panel;
TableFilters.Search = Search;
TableFilters.FilterList = FilterList;
TableFilters.QuickApply = QuickApply;
TableFilters.ActivePills = ActivePills;
export default TableFilters;